/**
 * Browser session for Auth Utils / api-dev-iam (suite-aligned key names).
 * - Fingerprint: X-XSRF-Token on every BFF + IAM request
 * - IAM JWT: Authorization Bearer (cross-origin; HttpOnly session cookie often not available)
 * - Optional session id when returned by verify-otp (forwarded if present)
 */
export const FP_KEY = 'authutils_fingerprint'
export const IAM_JWT_KEY = 'leap_seekho_iam_jwt'
export const IAM_SESSION_ID_KEY = 'leap_iam_session_id'
export const IAM_MFA_TOKEN_KEY = 'leap_seekho_iam_mfa_token'

export const getFingerprint = (): string => {
  try {
    return sessionStorage.getItem(FP_KEY) || ''
  } catch {
    return ''
  }
}

export const setFingerprint = (fp: string): void => {
  try {
    sessionStorage.setItem(FP_KEY, fp)
  } catch {
    /* private mode */
  }
}

export const getIamAccessToken = (): string => {
  try {
    return sessionStorage.getItem(IAM_JWT_KEY) || ''
  } catch {
    return ''
  }
}

export const setIamAccessToken = (token: string): void => {
  try {
    sessionStorage.setItem(IAM_JWT_KEY, token)
  } catch {
    /* ignore */
  }
}

export const clearIamAccessToken = (): void => {
  try {
    sessionStorage.removeItem(IAM_JWT_KEY)
  } catch {
    /* ignore */
  }
}

export const getSessionId = (): string => {
  try {
    return sessionStorage.getItem(IAM_SESSION_ID_KEY) || ''
  } catch {
    return ''
  }
}

export const setSessionId = (id: string): void => {
  try {
    if (id) sessionStorage.setItem(IAM_SESSION_ID_KEY, id)
    else sessionStorage.removeItem(IAM_SESSION_ID_KEY)
  } catch {
    /* ignore */
  }
}

export const getPendingIamMfaToken = (): string => {
  try {
    return sessionStorage.getItem(IAM_MFA_TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export const setPendingIamMfaToken = (token: string): void => {
  try {
    sessionStorage.setItem(IAM_MFA_TOKEN_KEY, token)
  } catch {
    /* ignore */
  }
}

export const clearPendingIamMfaToken = (): void => {
  try {
    sessionStorage.removeItem(IAM_MFA_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

/** Clear fingerprint, JWT, session id (keeps MFA pending only when logging out mid-flow — callers clear MFA explicitly). */
export const clearAuthCredentials = (): void => {
  try {
    sessionStorage.removeItem(FP_KEY)
    sessionStorage.removeItem(IAM_JWT_KEY)
    sessionStorage.removeItem(IAM_SESSION_ID_KEY)
  } catch {
    /* ignore */
  }
}

export function clearLegacyMockTokens(): void {
  try {
    localStorage.removeItem('cs_access_token')
    localStorage.removeItem('cs_fingerprint')
  } catch {
    /* ignore */
  }
}
